import { ApiServiceBase } from '../../base/api-service-base';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../../authentication/auth.service';
import { CommentViewModel } from '../../models/product-model/product-comment';

@Injectable({
    providedIn: 'root'
})
export class ProductCommentService extends ApiServiceBase {
    private readonly PATH = "/product/comments"
    constructor(
        private httpClient: HttpClient,
        private authService: AuthService
    ) {
        super(httpClient, authService);
    }

    public get(operatingProductId): Observable<CommentViewModel[]> {
        return this.httpGet<CommentViewModel[]>(this.PATH + '/' + operatingProductId , null)
            .pipe(
                map(res => res.body)
            )
    }
}